module.exports = __webpack_public_path__ + "img/view-shared-screen.f84dd58.svg";